/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    const readMoreButtons = document.querySelectorAll('.read-more-btn');
    
    readMoreButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const columnText = this.previousElementSibling;
        const isExpanded = columnText.classList.contains('ellipsis');
        
        // Reset all other text elements to ellipsis
        readMoreButtons.forEach(function(otherButton) {
          if (otherButton !== button) {
            const otherColumnText = otherButton.previousElementSibling;
            otherColumnText.classList.add('ellipsis');
            otherButton.textContent = otherButton.dataset.rmText;
          }
        });
        
        // Toggle current element
        if (!isExpanded) {
          columnText.classList.add('ellipsis');
          this.textContent = this.dataset.rmText;
        } else {
          columnText.classList.remove('ellipsis');
          this.textContent = this.dataset.rlText;
        }
      });
    });

    // Floating Video Popup functionality
    initFloatingVideoPopups();
  });

  // Floating Video Popup Functions
  function initFloatingVideoPopups() {
    // Handle video trigger clicks (open popup)
    const videoTriggers = document.querySelectorAll('.floating-video-trigger');
    videoTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        const sectionId = this.dataset.section;
        openVideoPopup(sectionId);
      });
    });

    // Handle close popup buttons
    const closeButtons = document.querySelectorAll('.floating-video-close-popup');
    closeButtons.forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function() {
        const sectionId = this.dataset.section;
        closeVideoPopup(sectionId);
      });
    });

    // Handle destroy buttons
    const destroyButtons = document.querySelectorAll('.floating-video-destroy');
    destroyButtons.forEach(function(destroyBtn) {
      destroyBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const sectionId = this.dataset.section;
        destroyFloatingVideo(sectionId);
      });
    });

    // Handle overlay clicks (close popup)
    const overlays = document.querySelectorAll('.floating-video-popup-overlay');
    overlays.forEach(function(overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          const sectionId = this.id.replace('floating-video-popup-', '');
          closeVideoPopup(sectionId);
        }
      });
    });
  }

  function openVideoPopup(sectionId) {
    const popup = document.getElementById('floating-video-popup-' + sectionId);
    const video = document.getElementById('floating-video-large-' + sectionId);
    const floatingBtn = document.getElementById('floating-video-btn-' + sectionId);
    
    if (popup && video && floatingBtn) {
      popup.style.display = 'flex';
      floatingBtn.style.display = 'none';
      video.muted = false;
      video.play().catch(function(error) {
        console.log('Video autoplay failed:', error);
      });
    }
  }

  function closeVideoPopup(sectionId) {
    const popup = document.getElementById('floating-video-popup-' + sectionId);
    const video = document.getElementById('floating-video-large-' + sectionId);
    const floatingBtn = document.getElementById('floating-video-btn-' + sectionId);
    
    if (popup && video && floatingBtn) {
      popup.style.display = 'none';
      floatingBtn.style.display = 'block';
      video.pause();
      video.currentTime = 0;
      video.muted = true;
    }
  }

  function destroyFloatingVideo(sectionId) {
    const floatingVideo = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (floatingVideo) {
      floatingVideo.remove();
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();